import React, { Component } from 'react';
import Layout from './Layout';
import { CardGroup, Card, CardTitle, CardSubtitle, CardText, CardImg, CardBody } from 'reactstrap';

const FavBooks = () => (
    <div>
        <Layout title='Self Study' className='container'>
            <div>
                <ul class="list-group">
                    <li class="list-group-item"><b>JavaScript:</b> The JavaScript language(Ilya Kantor),JavaScript & jQuery(John Ducket)</li>
                    <li class="list-group-item"><b>Databases:</b> Database System Concepts (Abraham Silberschatz, Henry F. Korth, S. Sudasrshan)</li>
                    <li class="list-group-item"><b>Entrepreneurial Book:</b> The Lean Startup (Eric Ries)</li>
                    <li class="list-group-item"><b>Algorithm: </b>Introduction to Algorithms (Thomas H. Corman), Programming Challenges(Steven S. Skiena)</li>
                    <li class="list-group-item"><b>Java and Object Orientated Programming:</b> Head First Java (K. Sierra und B. Bates)</li>
                </ul>
            </div>
        </Layout >
    </div >
)

export default FavBooks;